// extracted by mini-css-extract-plugin
module.exports = {"header":"movimentos-processo_header__1krMK","movimentosProcesso":"movimentos-processo_movimentosProcesso__RGdbp"};